import React from 'react';
// Helpers
import { getGlobalCssVariables } from '../../../helpers/general';

interface IChevronDownIcon extends React.HTMLProps<SVGElement> {
    className?: string;
    stroke?: string;
    onClick?: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
}

const ChevronDownIcon = (props: IChevronDownIcon) => {
    const [colorDarkGreyAdjusted] = getGlobalCssVariables(['--color-dark-grey-adjusted']);
    return (
        <svg
            className={props.className || ''}
            style={props.style || {}}
            viewBox="0 0 16 14"
            role="img"
            aria-label="chevron"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={props.onClick}
        >
            <path d="M1 4L8 11L15 4" stroke={props.stroke || colorDarkGreyAdjusted} />
        </svg>
    );
};

export default ChevronDownIcon;
